import { useState, useRef } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { getFullInformationCreditService } from "../services/home.service"; // ajustar ruta real

const styles = `
  .ca-root {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .ca-root * { box-sizing: border-box; }

  .ca-root .p-accordion .p-accordion-header .p-accordion-header-link {
    background: #ffffff !important;
    border: 1px solid #e8eaed !important;
    border-radius: 12px !important;
    padding: 16px 18px !important;
    color: #1a1d23 !important;
    box-shadow: none !important;
  }
  .ca-root .p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {
    background: #fafbfc !important;
    border-color: #d1d5db !important;
  }
  .ca-root .p-accordion .p-accordion-header.p-highlight .p-accordion-header-link {
    background: #ffffff !important;
    border-color: #00A86B !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  .ca-root .p-accordion .p-accordion-content {
    background: #ffffff !important;
    border: 1px solid #00A86B !important;
    border-top: none !important;
    border-radius: 0 0 12px 12px !important;
    padding: 4px 18px 18px !important;
    overflow: hidden !important;
  }
  .ca-root .p-accordion .p-accordion-tab {
    margin-bottom: 10px;
    overflow: hidden;
    border-radius: 12px;
  }
  .ca-root .p-accordion-header-link .p-icon,
  .ca-root .p-accordion-toggle-icon { color: #6b7280 !important; }

  .ca-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
  }
  .ca-header-left { display: flex; align-items: center; gap: 12px; min-width: 0; }
  .ca-header-icon {
    width: 38px; height: 38px; border-radius: 10px;
    background: #f0fdf8; color: #00A86B;
    display: flex; align-items: center; justify-content: center;
    font-size: 1rem; flex-shrink: 0;
  }
  .ca-header-title { font-weight: 700; font-size: 0.9rem; color: #1a1d23; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .ca-header-sub { font-size: 0.72rem; color: #9ca3af; margin-top: 1px; }
  .ca-header-count {
    background: #f4f6f9; border-radius: 20px; padding: 4px 12px;
    font-size: 0.7rem; font-weight: 600; color: #6b7280; white-space: nowrap; flex-shrink: 0;
  }

  .ca-section { padding-top: 14px; }
  .ca-section-label {
    font-size: 0.66rem; font-weight: 700; letter-spacing: 0.6px; text-transform: uppercase;
    color: #9ca3af; margin: 0 0 8px; display: flex; align-items: center; gap: 6px;
  }
  .ca-section-count {
    background: #f4f6f9; color: #6b7280; border-radius: 10px;
    padding: 1px 7px; font-size: 0.64rem; font-weight: 700;
  }
  .ca-section-count.warning { background: #fffbeb; color: #b45309; }
  .ca-section-count.info    { background: #eff6ff; color: #1d4ed8; }
  .ca-section-count.success { background: #f0fdf8; color: #047857; }
  .ca-section-count.danger  { background: #fef2f2; color: #b91c1c; }

  .ca-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 6px; width: 100%; }

  .ca-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 20px;
    background: #ffffff;
    border: 1px solid #eef1f4;
    border-radius: 10px;
    padding: 14px 16px;
    width: 100%;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
  }
  .ca-row:hover { border-color: #d1e7dd; background: #fafffd; }

  .ca-row-left { display: flex; align-items: center; gap: 14px; flex: 1 1 180px; min-width: 0; }
  .ca-row-bar { width: 3px; align-self: stretch; border-radius: 2px; flex-shrink: 0; min-height: 34px; }
  .ca-row-bar.warning { background: #f59e0b; }
  .ca-row-bar.info    { background: #3b82f6; }
  .ca-row-bar.success { background: #00A86B; }
  .ca-row-bar.danger  { background: #ef4444; }

  .ca-row-id { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
  .ca-row-number { font-weight: 700; font-size: 0.83rem; color: #1a1d23; }
  .ca-row-date { font-size: 0.7rem; color: #9ca3af; }

  .ca-row-mid { display: flex; align-items: center; gap: 20px; flex-wrap: wrap; flex: 2 1 220px; min-width: 0; }
  .ca-row-amount-block { display: flex; flex-direction: column; gap: 2px; }
  .ca-row-amount-label { font-size: 0.62rem; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.4px; font-weight: 600; }
  .ca-row-amount { font-size: 0.98rem; font-weight: 700; color: #1a1d23; letter-spacing: -0.3px; }

  .ca-row-tags { display: flex; gap: 6px; flex-wrap: wrap; }
  .ca-row-tag {
    font-size: 0.68rem; color: #6b7280; background: #f8fafc;
    border: 1px solid #eef1f4; border-radius: 6px; padding: 3px 8px; white-space: nowrap;
  }
  .ca-row-tag b { color: #1a1d23; font-weight: 600; }

  .ca-row-status {
    font-size: 0.68rem; font-weight: 700; padding: 5px 12px; border-radius: 20px;
    white-space: nowrap; flex-shrink: 0; margin-left: auto;
  }
  .ca-row-status.warning { background: #fffbeb; color: #b45309; }
  .ca-row-status.info    { background: #eff6ff; color: #1d4ed8; }
  .ca-row-status.success { background: #f0fdf8; color: #047857; }
  .ca-row-status.danger  { background: #fef2f2; color: #b91c1c; }

  .ca-row-rejection {
    flex-basis: 100%; width: 100%;
    background: #fef2f2; border: 1px solid #fee2e2; border-radius: 8px;
    padding: 9px 12px; font-size: 0.72rem; color: #b91c1c; line-height: 1.5;
  }

  .ca-empty { font-size: 0.8rem; color: #9ca3af; padding: 14px 0 4px; font-style: italic; }

  /* ── Fix universal de la "X" del Dialog ── */
  .p-dialog .p-dialog-header-icon {
    color: #6b7280 !important;
    background: transparent !important;
    border-radius: 8px !important;
    width: 30px !important;
    height: 30px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .p-dialog .p-dialog-header-icon:hover { background: #f3f4f6 !important; color: #374151 !important; }

  /* ── Popup de resumen ── */
  .p-dialog.cs-summary-dialog {
    border-radius: 16px !important;
    overflow: hidden;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    box-shadow: 0 20px 48px rgba(0,0,0,0.18) !important;
  }
  .p-dialog.cs-summary-dialog .p-dialog-header {
    background: #ffffff !important;
    padding: 20px 24px 14px !important;
    border-bottom: 1px solid #f1f3f5 !important;
  }
  .p-dialog.cs-summary-dialog .p-dialog-title {
    font-size: 1.02rem !important;
    font-weight: 800 !important;
    color: #1a1d23 !important;
  }
  .p-dialog.cs-summary-dialog .p-dialog-content {
    padding: 20px 24px 24px !important;
    background: #ffffff !important;
  }

  .cs-loading {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 10px; padding: 48px 0; color: #9ca3af; font-size: 0.82rem;
  }
  .cs-loading i { font-size: 1.6rem; }

  .cs-header-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 4px; flex-wrap: wrap; gap: 10px;
  }
  .cs-credit-number { font-size: 1.1rem; font-weight: 800; color: #1a1d23; }
  .cs-type-name { font-size: 0.76rem; color: #9ca3af; margin-bottom: 18px; }

  .cs-progress-block { margin-bottom: 22px; }
  .cs-progress-labels {
    display: flex; justify-content: space-between; align-items: baseline;
    margin-bottom: 8px;
  }
  .cs-progress-paid { font-size: 0.8rem; color: #374151; }
  .cs-progress-paid b { color: #00A86B; font-weight: 700; }
  .cs-progress-pct { font-size: 0.9rem; font-weight: 800; color: #00A86B; }
  .cs-progress-track {
    width: 100%; height: 10px; border-radius: 6px;
    background: #f1f3f5; overflow: hidden;
  }
  .cs-progress-fill {
    height: 100%; border-radius: 6px;
    background: linear-gradient(90deg, #00A86B 0%, #059669 100%);
    transition: width 0.4s ease;
  }
  .cs-progress-fill.danger { background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%); }
  .cs-progress-footer {
    display: flex; justify-content: space-between; margin-top: 6px;
    font-size: 0.68rem; color: #9ca3af;
  }

  .cs-stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px 20px;
    margin-bottom: 20px;
  }
  .cs-stat { display: flex; flex-direction: column; gap: 2px; }
  .cs-stat-label {
    font-size: 0.64rem; color: #9ca3af; text-transform: uppercase;
    letter-spacing: 0.4px; font-weight: 600;
  }
  .cs-stat-value { font-size: 0.9rem; font-weight: 700; color: #1a1d23; }
  .cs-stat-value.highlight { color: #00A86B; }
  .cs-stat-value.danger { color: #dc2626; }

  .cs-mora-banner {
    display: flex; align-items: center; gap: 8px;
    background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px;
    padding: 10px 14px; font-size: 0.78rem; color: #b91c1c; margin-bottom: 18px;
  }
  .cs-mora-banner b { font-weight: 800; }

  .cs-rejection {
    background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px;
    padding: 12px 14px; font-size: 0.8rem; color: #b91c1c; line-height: 1.5;
  }

  .cs-status-pill {
    font-size: 0.68rem; font-weight: 700; padding: 5px 12px; border-radius: 20px; white-space: nowrap;
  }
  .cs-status-pill.warning { background: #fffbeb; color: #b45309; }
  .cs-status-pill.info    { background: #eff6ff; color: #1d4ed8; }
  .cs-status-pill.success { background: #f0fdf8; color: #047857; }
  .cs-status-pill.danger  { background: #fef2f2; color: #b91c1c; }

  @media (max-width: 640px) {
    .ca-header-count { display: none; }
    .cs-stats-grid { grid-template-columns: 1fr; }
  }
`;

const currency = (value: any) => {
  if (value === null || value === undefined) return "—";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "—";
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
};

const formatDate = (value: any) => {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const statusLabels: Record<string, string> = {
  pendiente: "Pendiente",
  aprobado: "Aprobado",
  activo: "Activo",
  rechazado: "Rechazado",
};

const statusTone: Record<string, "warning" | "info" | "success" | "danger"> = {
  pendiente: "warning",
  aprobado: "info",
  activo: "success",
  rechazado: "danger",
};

function CreditRow({ credit, tone, onClick }: { credit: any; tone: "warning" | "info" | "success" | "danger"; onClick: () => void }) {
  const isRejected = credit.status === "rechazado";
  const isDisbursed = credit.status === "activo";

  const mainAmount = isDisbursed
    ? credit.disbursedAmount
    : credit.approvedAmount ?? credit.requestedAmount;

  const amountLabel = isDisbursed
    ? "Monto desembolsado"
    : credit.status === "aprobado"
    ? "Monto aprobado"
    : "Monto solicitado";

  return (
    <div className="ca-row" onClick={onClick}>
      <div className="ca-row-left">
        <span className={`ca-row-bar ${tone}`} />
        <div className="ca-row-id">
          <span className="ca-row-number">{credit.creditNumber}</span>
          <span className="ca-row-date">Creado {formatDate(credit.createdAt)}</span>
        </div>
      </div>

      <div className="ca-row-mid">
        <div className="ca-row-amount-block">
          <span className="ca-row-amount-label">{amountLabel}</span>
          <span className="ca-row-amount">{currency(mainAmount)}</span>
        </div>

        <div className="ca-row-tags">
          <span className="ca-row-tag">Plazo: <b>{credit.termMonths} meses</b></span>
          {credit.interestRate && (
            <span className="ca-row-tag">Tasa: <b>{credit.interestRate}%</b></span>
          )}
          {isDisbursed && (
            <span className="ca-row-tag">Desembolsado: <b>{formatDate(credit.disbursementDate)}</b></span>
          )}
        </div>
      </div>

      <span className={`ca-row-status ${tone}`}>{statusLabels[credit.status] ?? credit.status}</span>

      {isRejected && credit.rejectionReason && (
        <div className="ca-row-rejection">
          <i className="pi pi-info-circle" style={{ marginRight: 6 }} />
          {credit.rejectionReason}
        </div>
      )}
    </div>
  );
}

function CreditSection({
  title,
  credits,
  tone,
  onSelect,
}: {
  title: string;
  credits: any[];
  tone: "warning" | "info" | "success" | "danger";
  onSelect: (credit: any) => void;
}) {
  if (!credits || credits.length === 0) return null;

  return (
    <div className="ca-section">
      <div className="ca-section-label">
        {title}
        <span className={`ca-section-count ${tone}`}>{credits.length}</span>
      </div>
      <div className="ca-list">
        {credits.map((credit: any) => (
          <CreditRow key={credit.idCredito} credit={credit} tone={tone} onClick={() => onSelect(credit)} />
        ))}
      </div>
    </div>
  );
}

interface CreditsAccordionProps {
  creditosPorTipo: any[];
}

function CreditsAccordion({ creditosPorTipo }: CreditsAccordionProps): JSX.Element {
  const toast = useRef<Toast>(null);

  const [detailVisible, setDetailVisible] = useState<boolean>(false);
  const [detailData, setDetailData] = useState<any | null>(null);
  const [loadingDetail, setLoadingDetail] = useState<boolean>(false);

  const openCreditDetail = async (credit: any) => {
    if (!credit?.cliente?.ClientId && !credit?.idCliente) {
      // fallback si el crédito viene sin cliente embebido en esta vista
    }
    setDetailVisible(true);
    setLoadingDetail(true);
    setDetailData(null);
    try {
      const idClient = credit.cliente?.ClientId ?? credit.idCliente;
      const response: any = await getFullInformationCreditService(idClient, credit.idCredito);
      setDetailData(response?.data ?? response ?? null);
    } catch (err: any) {
      toast.current?.show({
        severity: "error",
        summary: "No se pudo cargar el crédito",
        detail: err?.response?.data?.message ?? "Intenta nuevamente",
        life: 4000,
      });
      setDetailVisible(false);
    } finally {
      setLoadingDetail(false);
    }
  };

  const closeCreditDetail = () => {
    setDetailVisible(false);
    setDetailData(null);
  };

  if (!creditosPorTipo || creditosPorTipo.length === 0) {
    return (
      <>
        <style>{styles}</style>
        <div className="ca-empty">Aún no tienes créditos registrados.</div>
      </>
    );
  }

  // ── Cálculos derivados para el popup ──
  const totalAmount = detailData
    ? Number(detailData.disbursedAmount ?? detailData.approvedAmount ?? detailData.requestedAmount ?? 0)
    : 0;
  const remaining = detailData ? Number(detailData.remainingBalance ?? 0) : 0;
  const paidAmount = Math.max(totalAmount - remaining, 0);
  const progressPct = totalAmount > 0 ? Math.min((paidAmount / totalAmount) * 100, 100) : 0;

  const totalInstallments = detailData?.termMonths ?? 0;
  const paidInstallments = detailData?.paidInstallments ?? 0;

  // Próxima fecha de pago estimada (a partir del primer pago + cuotas ya pagadas)
  let nextPaymentDate: string | null = null;
  if (detailData?.firstPaymentDate) {
    const base = new Date(detailData.firstPaymentDate);
    base.setMonth(base.getMonth() + paidInstallments);
    nextPaymentDate = base.toISOString();
  }

  const isOverdue = (detailData?.daysOverdue ?? 0) > 0;

  return (
    <>
      <style>{styles}</style>
      <Toast ref={toast} />
      <div className="ca-root">
        <Accordion multiple activeIndex={[0]}>
          {creditosPorTipo.map((grupo: any) => {
            const total =
              (grupo.pendientesAprobacion?.length ?? 0) +
              (grupo.aprobadosPorDesembolsar?.length ?? 0) +
              (grupo.desembolsados?.length ?? 0) +
              (grupo.rechazados?.length ?? 0);

            return (
              <AccordionTab
                key={grupo.idTipoCredito}
                header={
                  <div className="ca-header">
                    <div className="ca-header-left">
                      <div className="ca-header-icon">
                        <i className="pi pi-wallet" />
                      </div>
                      <div>
                        <div className="ca-header-title">{grupo.nombreTipoCredito}</div>
                        <div className="ca-header-sub">Código: {grupo.codigoTipoCredito}</div>
                      </div>
                    </div>
                    <span className="ca-header-count">
                      {total} {total === 1 ? "crédito" : "créditos"}
                    </span>
                  </div>
                }
              >
                <CreditSection
                  title="Pendientes de aprobación"
                  credits={grupo.pendientesAprobacion}
                  tone="warning"
                  onSelect={openCreditDetail}
                />
                <CreditSection
                  title="Aprobados, por desembolsar"
                  credits={grupo.aprobadosPorDesembolsar}
                  tone="info"
                  onSelect={openCreditDetail}
                />
                <CreditSection
                  title="Activos / desembolsados"
                  credits={grupo.desembolsados}
                  tone="success"
                  onSelect={openCreditDetail}
                />
                <CreditSection
                  title="Rechazados"
                  credits={grupo.rechazados}
                  tone="danger"
                  onSelect={openCreditDetail}
                />
              </AccordionTab>
            );
          })}
        </Accordion>
      </div>

      {/* ── Popup de resumen del crédito ── */}
      <Dialog
        header="Resumen del crédito"
        visible={detailVisible}
        onHide={closeCreditDetail}
        className="cs-summary-dialog"
        style={{ width: "520px", maxWidth: "95vw" }}
        modal
      >
        {loadingDetail && (
          <div className="cs-loading">
            <i className="pi pi-spin pi-spinner" />
            Cargando información...
          </div>
        )}

        {!loadingDetail && detailData && (
          <>
            <div className="cs-header-row">
              <span className="cs-credit-number">{detailData.creditNumber}</span>
              <span className={`cs-status-pill ${statusTone[detailData.status] ?? "info"}`}>
                {statusLabels[detailData.status] ?? detailData.status}
              </span>
            </div>
            <div className="cs-type-name">{detailData.tipoCredito?.name}</div>

            {detailData.status === "rechazado" && detailData.rejectionReason && (
              <div className="cs-rejection" style={{ marginBottom: 18 }}>
                <i className="pi pi-info-circle" style={{ marginRight: 6 }} />
                {detailData.rejectionReason}
              </div>
            )}

            {(detailData.status === "activo" || detailData.status === "mora" || detailData.status === "pagado") && (
              <>
                {isOverdue && (
                  <div className="cs-mora-banner">
                    <i className="pi pi-exclamation-triangle" />
                    Este crédito tiene <b>{detailData.daysOverdue} días</b> en mora
                  </div>
                )}

                <div className="cs-progress-block">
                  <div className="cs-progress-labels">
                    <span className="cs-progress-paid">
                      Pagado: <b>{currency(paidAmount)}</b> de {currency(totalAmount)}
                    </span>
                    <span className="cs-progress-pct">{Math.round(progressPct)}%</span>
                  </div>
                  <div className="cs-progress-track">
                    <div
                      className={`cs-progress-fill ${isOverdue ? "danger" : ""}`}
                      style={{ width: `${progressPct}%` }}
                    />
                  </div>
                  <div className="cs-progress-footer">
                    <span>Cuota {paidInstallments} de {totalInstallments}</span>
                    <span>Saldo: {currency(remaining)}</span>
                  </div>
                </div>
              </>
            )}

            <div className="cs-stats-grid">
              <div className="cs-stat">
                <span className="cs-stat-label">Valor cuota</span>
                <span className="cs-stat-value">{currency(detailData.installmentValue)}</span>
              </div>
              <div className="cs-stat">
                <span className="cs-stat-label">Tasa de interés</span>
                <span className="cs-stat-value">
                  {detailData.interestRate ? `${detailData.interestRate}%` : "—"}
                </span>
              </div>
              <div className="cs-stat">
                <span className="cs-stat-label">Plazo total</span>
                <span className="cs-stat-value">{detailData.termMonths} meses</span>
              </div>
              <div className="cs-stat">
                <span className="cs-stat-label">Cuotas pagadas</span>
                <span className="cs-stat-value highlight">
                  {paidInstallments} / {totalInstallments}
                </span>
              </div>
              {nextPaymentDate && detailData.status !== "pagado" && (
                <div className="cs-stat">
                  <span className="cs-stat-label">Próximo pago estimado</span>
                  <span className="cs-stat-value">{formatDate(nextPaymentDate)}</span>
                </div>
              )}
              <div className="cs-stat">
                <span className="cs-stat-label">Saldo pendiente</span>
                <span className={`cs-stat-value ${remaining > 0 ? "danger" : "highlight"}`}>
                  {currency(remaining)}
                </span>
              </div>
              <div className="cs-stat">
                <span className="cs-stat-label">Fecha de aprobación</span>
                <span className="cs-stat-value">{formatDate(detailData.approvalDate)}</span>
              </div>
              <div className="cs-stat">
                <span className="cs-stat-label">Fecha de desembolso</span>
                <span className="cs-stat-value">{formatDate(detailData.disbursementDate)}</span>
              </div>
            </div>
          </>
        )}
      </Dialog>
    </>
  );
}

export default CreditsAccordion;